import { gql } from '@apollo/client'

export default gql`
  mutation renameProject($id: ID!, $name: String!) {
    renameProject(id: $id, name: $name) {
      id
      name
    }
  }
`
